import { mutationOptions, queryOptions } from '@tanstack/react-query';

import { API_MODULES } from '@lib/api/constants';
import DIContainer from '@lib/dicontainer';
import { AdminStoresFilters, StoreInput } from '@lib/types';

const usecase = DIContainer.getStoresUseCase();

export const storesKey = [API_MODULES.STORES];

export const storeSlugOptions = (slug: string) => queryOptions({
  queryKey: [...storesKey, 'slug-availability', slug],
  queryFn: ({ signal }) => usecase.checkSlug(slug, signal),
  enabled: slug.length > 0,
  staleTime: 0,
});

export const storesOptions = () =>
  queryOptions({
    queryKey: [...storesKey, 'list'],
    queryFn: ({ signal }) => usecase.list(signal),
  });

export const storeOptions = (slug: string) =>
  queryOptions({
    queryKey: [...storesKey, slug],
    queryFn: ({ signal }) => usecase.find(slug, signal),
  });

export const storeReviewsOptions = (slug: string) =>
  queryOptions({
    queryKey: [...storesKey, slug, 'reviews'],
    queryFn: ({ signal }) => usecase.listReviews(slug, signal),
  });

export const storeProgressOptions = (slug: string) =>
  queryOptions({
    queryKey: [...storesKey, slug, 'progress'],
    queryFn: ({ signal }) => usecase.findProgress(slug, signal),
  });

export const acknowledgeStorePromotionOptions = () =>
  mutationOptions({ mutationFn: () => usecase.acknowledgePromotion() });

export const myStoreOptions = (isStoreOwner = false) =>
  queryOptions({
    queryKey: [...storesKey, 'mine'],
    queryFn: ({ signal }) => usecase.findMine(signal),
    retry: false,
    enabled: isStoreOwner,
  });

export const saveStoreOptions = () =>
  mutationOptions({ mutationFn: (input: StoreInput) => usecase.save(input) });

export const adminStoresOptions = (
  filters: AdminStoresFilters = { page: 1, limit: 20 },
) =>
  queryOptions({
    queryKey: [...storesKey, 'admin', filters],
    queryFn: ({ signal }) => usecase.listAdmin(filters, signal),
  });

export const setStoreActiveOptions = () =>
  mutationOptions({
    mutationFn: ({ id, active }: { id: string; active: boolean }) =>
      usecase.setActive(id, active),
  });

export const setMyStoreActiveOptions = () =>
  mutationOptions({
    mutationFn: (active: boolean) => usecase.setMineActive(active),
  });
